import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import BsModal from "../../Misc/BsModal";
import compressor from "../../Editor/compressor";

export default class ProfileAvatar extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      fileInputRef: React.createRef(),
    };
  }

  handleSave = async () => {
    if (this.state.fileInputRef.current) {
      if (this.state.fileInputRef.current.files[0]) {
        this.setState({ pending: true });
        const file = this.state.fileInputRef.current.files[0];

        const maxSize = window.appConfig.maxFileSize;
        if (maxSize && file.size > maxSize) {
          this.context.toast(
            `Превышен максимальный размер загружаемого файла: ${Math.round(
              maxSize / 1024
            )} Кб`,
            "error"
          );
          this.setState({ pending: false });
          return;
        }

        let { readerResult } = await this.context.api.toBase64(file);
        compressor(readerResult, { maxWidth: 200, maxHeight: 200 }).then(
          (compressedResult) => {
            this.save(compressedResult);
          }
        );
      }
    }
  };

  save = async (picture) => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/user/profile/set", {
      picture,
    });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      document.location.reload();
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
      this.setState({ pending: false });
    }
  };

  render() {
    return (
      <>
        <BsModal center {...this.props}>
          <Blocker on={this.state.pending}>
            <div>
              <div className="form-group">
                <label>Загрузить файл</label>
                <input
                  ref={this.state.fileInputRef}
                  type="file"
                  className="form-control"
                  accept="image/png, image/gif, image/jpeg"
                />
              </div>
              <div className="mt-5 pt-5 border-top d-flex align-items-center justify-content-between">
                <div>
                  <button
                    className="btn btn-primary mr-2"
                    onClick={this.handleSave}
                  >
                    Сохранить
                  </button>

                  <button
                    className="btn btn-light mr-2"
                    onClick={() => this.props.onClose()}
                  >
                    Отмена
                  </button>
                </div>
                <div>
                  {this.context.user.show.picture && (
                    <button
                      className="btn btn-light mr-2"
                      onClick={() => this.save("")}
                    >
                      <i className="fa fa-times mr-2"></i>
                      Удалить текущий
                    </button>
                  )}
                </div>
              </div>
            </div>
          </Blocker>
        </BsModal>
      </>
    );
  }
}
